export default "__VITE_ASSET__BnoGllxH__"